export default "__VITE_ASSET__a876b22c__"